export default "aae2372a1cf222fc.svg"